export enum stateRequest {
  excuted = 1,
  error = 0,
  notExcuted = -1,
}

export enum statisticsType {
  userRegistered = 0,
  userActive = 1,
  licenseAdcquired = 2,
  totalHoursOfStudy = 3,
  averageHoursOfStudy = 4,
  coursesCertified = 5,
}

export enum statisticsAffiliates {
  USERS_REGISTERS = 0,
  USERS_CERTIFICATIONS = 1,
  RECORDS_INFO = 2,
  BENEFICIO_DAYS = 3
}

export enum RoleType {
  FULL = 0,
  LIMITED = 1,
  VIEW = 2,
}

export enum configGeneral {
  DELETE_USER = 0,
  UPGRADE_BUSINESS = 1,
  DELETE_LIST = 2,
  DELETE_CAMPAIGN = 3,
  DELETE_CAMPAIGNS = 4,
  CREATE_LIST = 5,
  CREATE_CAMPAIGN = 6,
  DELETE_COMMISIONS = 7,
  DISABLED_CAMPAIGN = 8,

  // Resources
  CREATE_VERSION = 9,
  DISABLED_RESOURCES = 10,
  DELETE_RESOURCES = 11
}

export enum pageAssign {
  PAGE_TYPE_SELECTION = 0,
  PAGE_CONTENT = 1,
  PAGE_CAMPAIGN = 2,
  PAGE_BUSINESS_LINK_RESULT = 3,
}

export enum typeContent {
  WEB_PAGES = 0,
  COURSES = 1,
  CATEGORIES = 2,
  SELECTED_CONTENT = 3,
  CAMPAIGNS = 4,
  PATHWAYS = 5
}